import { render, staticRenderFns } from "./OrderMenuGridWide.vue?vue&type=template&id=b37ca720&scoped=true"
import script from "./OrderMenuGridWide.vue?vue&type=script&lang=js"
export * from "./OrderMenuGridWide.vue?vue&type=script&lang=js"
import style0 from "./OrderMenuGridWide.vue?vue&type=style&index=0&id=b37ca720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37ca720",
  null
  
)

export default component.exports